var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_625)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.975 4L4 10.5532V19.9149L13.975 26L23 19.9149V10.5532L13.975 4Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.03827 10.0203L10.3569 13.5481C10.4805 13.618 10.616 13.6509 10.7555 13.6509C11.0625 13.6509 11.3455 13.4782 11.493 13.1986C11.6007 12.9972 11.6246 12.7628 11.5608 12.5408C11.497 12.3187 11.3535 12.1378 11.1582 12.0268L4.83956 8.49893C4.50868 8.3139 4.30935 7.97263 4.30536 7.58612C4.30536 7.19962 4.49672 6.85424 4.82361 6.6651L13.1275 1.86671C13.4385 1.6858 13.8092 1.6858 14.1201 1.86671C15.2244 2.49992 16.9027 3.46618 18.4375 4.34197C18.4933 4.0706 18.585 3.79922 18.7206 3.54019C18.8641 3.26881 19.0475 3.03444 19.2548 2.82886C17.7239 1.95306 16.0416 0.986804 14.9374 0.353599C14.1122 -0.11925 13.1315 -0.11925 12.3103 0.353599L4.00239 5.15609C3.13333 5.65772 2.61907 6.57053 2.62704 7.59846C2.63502 8.62639 3.16124 9.53097 4.03827 10.0203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6644 9.33364C23.8152 8.8279 22.7668 8.84846 21.9296 9.38298L14.2676 14.3171C13.5141 14.8022 13.0477 15.6369 13.0198 16.5538L12.7128 26.2863C12.7009 26.644 12.5135 26.9606 12.2105 27.1374C11.9075 27.3101 11.5488 27.3101 11.2458 27.1333L2.80636 22.154C2.50338 21.9731 2.31203 21.64 2.31203 21.2782V15.8713C2.04892 15.9659 1.76588 16.0152 1.47486 16.0152C1.18385 16.0152 0.900805 15.9617 0.637695 15.8713V21.2782C0.637695 22.2609 1.15195 23.1696 1.97716 23.6589L10.4166 28.6382C10.8192 28.8767 11.2777 29.0041 11.7361 29.0041C12.1946 29.0041 12.6331 28.8808 13.0317 28.6546C13.853 28.1818 14.3632 27.3183 14.3911 26.3521L14.6981 16.6196C14.7101 16.2825 14.8815 15.9741 15.1566 15.7932L22.8186 10.855C23.1296 10.6535 23.5083 10.6453 23.8272 10.8344C24.1461 11.0236 24.3295 11.3648 24.3175 11.7431L24.0066 21.8374C23.9946 22.1787 23.8192 22.4912 23.5362 22.668L20.9769 24.2674C21.3476 24.7197 21.5987 25.2584 21.7183 25.8299L24.4053 24.1482C25.1786 23.6671 25.657 22.8201 25.6849 21.8909L25.9959 11.7966C26.0278 10.7851 25.5175 9.83939 24.6644 9.33364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9342 3.53197C22.6996 3.95959 22.9867 4.95052 22.5721 5.73997C22.1575 6.52942 21.1967 6.82547 20.4313 6.39785C19.6659 5.97023 19.3789 4.9793 19.7935 4.18985C20.2081 3.4004 21.1688 3.10435 21.9342 3.53197Z",
    fill: "url(#paint0_linear_23_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72441 14.1266C3.13232 13.4071 2.89757 12.4829 2.20007 12.0622C1.50257 11.6414 0.606462 11.8836 0.19855 12.603C-0.209361 13.3224 0.0253939 14.2466 0.722892 14.6674C1.42039 15.0881 2.3165 14.846 2.72441 14.1266Z",
    fill: "url(#paint1_linear_23_625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3748 24.6333C20.4312 25.2213 20.8219 26.5823 20.2478 27.6719C19.6777 28.7615 18.3582 29.1645 17.3018 28.5724C16.2453 27.9844 15.8547 26.6234 16.4287 25.5338C16.9988 24.4442 18.3183 24.0412 19.3748 24.6333Z",
    fill: "url(#paint2_linear_23_625)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23_625",
    x1: 19.5981,
    y1: 4.96697,
    x2: 22.7594,
    y2: 4.96697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D4D800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AEB908"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23_625",
    x1: -0.00167348,
    y1: 13.365,
    x2: 2.92442,
    y2: 13.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D4D800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AEB908"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23_625",
    x1: 16.1656,
    y1: 26.6028,
    x2: 20.5109,
    y2: 26.6028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#D4D800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#AEB908"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon1);
export default __webpack_public_path__ + "static/media/logo-icon-1.941cf34a2c51d4c30d6406cdd6b94328.svg";
export { ForwardRef as ReactComponent };